// Application JavaScript for the merchant portal (formerly
// app/assets/javascripts/sepaone_app.js; the validator registrations moved to
// ./validators). Runs on DOM ready.
import $ from "jquery";
import I18n from "i18n-js";
import { AmountFormatter } from "./amount_formatter";
import "./validators";

$(function(){
  $(document).foundation();

  $('.contact_age').hide();
  $('#contact_age').prop('disabled', true);

  $("[data-validate]").validate();

  var i18n = $('body').data('i18n');

  if (i18n) {
    I18n.defaultLocale = i18n.default_locale
    I18n.locale        = i18n.locale
    I18n.fallbacks     = true
    I18n.locales[I18n.locale] = function(locale){ return i18n.fallbacks.slice(); };
  }

  $(document).on('blur change', '[data-format-money]', function() {
    var localizedField   = $(this);
    var unlocalizedField = $(localizedField.data('format-money'));
    AmountFormatter.centifyField(localizedField, unlocalizedField)
  })

  $(document).on('mouseover', '[data-explain-balance]', function(e) {
    var balance = $(e.target)
    var icon = balance.children("span")
    $('#transaction_amount,#refund_amount').addClass("highlight")
    icon.hide()
    balance.text(balance.data('balance').amount + " = " + balance.data('balance').transaction_volume  + " - " + balance.data('balance').refund_volume )
    balance.append(icon)
  })
  $(document).on('mouseout', '[data-explain-balance]', function(e) {
    var balance = $(e.target)
    var icon = balance.children("span")
    $('#transaction_amount,#refund_amount').removeClass("highlight")
    icon.show()
    balance.text(balance.data('balance').amount + "\n")
    balance.append(icon)
  })

  // Features for dashboard
  if($('.dashboards_show').length > 0) {
    var $chartElement = $("#revenue-chart");
    var data = {
      labels: $chartElement.data('labels'),
      datasets: [
        {
          fillColor: "RGBA(30, 174, 183, 0.2)",
          strokeColor: "RGBA(30, 174, 183, 1)",
          data: $chartElement.data('values')
        }
      ]
    };

    var canvas = document.getElementById("revenue-chart").getContext("2d");
    var myBarChart = new window.Chart(canvas).Line(data, {
      tooltipFontSize: 12,
      tooltipTemplate: "<%if (label){%><%=label%>: <%}%><%= value %> EUR",
      scaleLabel: "<%=value%> EUR",
      responsive: true,
      bezierCurveTension: 0.2
    });
  }

  if($('body.bank_accounts_new, body.bank_accounts_create').length > 0) {
    var $countrySelect = $('#bank_account_country');
    var $optionalInputContainers = $('.input.bank_account_account_number, .input.bank_account_bank_code, .input.bank_account_abi, .input.bank_account_cin, .input.bank_account_cab')
    var countries = $('form.new_bank_account').data('countries');
    var countryData = undefined;

    var displayFormFields = function() {
      countryData = countries[$countrySelect.val()];
      if(countryData != undefined) {
        $.each(countryData.fields, function(i, fieldData) {
          $('.input.bank_account_' + fieldData.name).removeClass('hide');
        });
      }
    }

    $countrySelect.on('change', function(e) {
      e.preventDefault();

      // Always reset view and input fields
      $('#bank_account_account_number, #bank_account_bank_code, #bank_account_abi, #bank_account_cin, #bank_account_cab').val('');
      $optionalInputContainers.addClass('hide');

      displayFormFields();
    });
    displayFormFields();
  }

  if($('.mandates_new, .mandates_create').length > 0) {
    var $form = $('#new_mandate');

    // Allow customer to generate references
    var $referenceField = $('#mandate_reference');
    $('.js-suggest-reference').click(function(e) {
      e.preventDefault();
      $.get('/mandates/suggest', function(data) {
        $referenceField.val(data.reference);
      });
    });
  }
});
